module.exports = __webpack_public_path__ + "img/1_tools.92528103.png";